<template>
  <widgetModal :title="saveAs ? `Save as template` : form.id ? `Edit template` : `Add New template`"
    :subtitle="saveAs ? `Please note that before saving the email as a template, it's important to review and remove any private or confidential information that may not be suitable for reuse. I encourage you to edit the email as necessary before saving it as a template.` : `Fill in the details below for template.`"
    btnlefttext="Save" btncentertext="Cancel" btnrighttext="" :leftloading="save_template_loading" :hiderightbtn="true"
    :centerloading="false" :footerhidden="false" footer_padding="20px 20px" header_padding="20px 20px"
    body_padding="0px 20px" width="580px" @onLeftClick="saveTemplate()" @onCenterClick="onCancel">
    <div class="widget-modal-body-noscoll">
      <widgetInputWrapper title="Title">
        <widgetInput v-model="form.title" type="text" placeholder="Add Your Subject"></widgetInput>
      </widgetInputWrapper>
      <widgetInputWrapper title="Type">
        <widgetSelect v-model="form.type" :opt="[
          { label: 'Students', value: 'students' },
          { label: 'Companies', value: 'companies' },
        ]" placeholder="Select type"></widgetSelect>
      </widgetInputWrapper>
      <widgetInputWrapper title="Message*">
        <div class="template-message-editor-options">
          <widgetDropdown v-model="showTemplateValiables" :right="true" :hover="false" :interactive="true"
            class="btn-template-message-properties">
            <widgetButton class="btn-transparent-primary outline">
              Template variables
              <img v-if="!showTemplateValiables" src="@/assets/icon/carret-bottom-gray.svg" class="btn-icon">
              <img v-else src="@/assets/icon/carret-top-gray.svg" class="btn-icon">
            </widgetButton>
            <div slot="dropdown">
              <div class="dropdown-widget-menu">
                <template v-if="form.type == 'students'">
                  <div class="divider">
                    <div class="divider-text">
                      Student
                    </div>
                    <div class="divider-line"></div>
                  </div>
                  <a class="dropdown-item" href="#" @click.prevent="addPropertyToEditor('Student name')">Student name</a>
                  <a class="dropdown-item" href="#" @click.prevent="addPropertyToEditor('Class')">Class</a>
                </template>
                <template v-if="form.type == 'companies'">
                  <div class="divider">
                    <div class="divider-text">
                      Company
                    </div>
                    <div class="divider-line"></div>
                  </div>
                  <a class="dropdown-item" href="#" @click.prevent="addPropertyToEditor('Company name')">Company name</a>
                  <a class="dropdown-item" href="#" @click.prevent="addPropertyToEditor('Company contact name')">Company
                    contact name</a>
                </template>
                <div class="divider">
                  <div class="divider-text">
                    More
                  </div>
                  <div class="divider-line"></div>
                </div>
                <a v-if="false" class="dropdown-item" href="#" @click.prevent="addPropertyToEditor('Sender')">Sender</a>
                <a v-if="false" class="dropdown-item" href="#" @click.prevent="addPropertyToEditor('Sender Email')">Sender
                  Email</a>
                <a class="dropdown-item" href="#" @click.prevent="addPropertyToEditor('Location')">Location</a>
                <a class="dropdown-item" href="#" @click.prevent="addPropertyToEditor('Date')">Date</a>
              </div>
            </div>
          </widgetDropdown>
          <html-editor placeholder="Type here..." v-model="form.message" id="edit-descr" class="second-row-options" />
        </div>
      </widgetInputWrapper>
    </div>
  </widgetModal>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "",
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
    phase: {
      type: String,
      default: "",
    },
    saveAs: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      showTemplateValiables: false,
      save_template_loading: false,
      form: {
        id: null,
        title: "",
        message: "",
        type: "students",
        phase: ""
      },
    };
  },
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.updateFormFields(vm.value);
    } else {
      vm.resetFormFields();
    }
  },
  computed: {},
  watch: {},
  methods: {
    updateFormFields(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.title = item.title;
      vm.form.message = item.description;
      vm.form.type = item.type;
    },
    resetFormFields() {
      let vm = this;
      vm.form.id = null;
      vm.form.title = "";
      vm.form.message = "";
      vm.form.type = "students";
    },
    addPropertyToEditor(property) {
      let vm = this;
      vm.showTemplateValiables = false;
      eventBus.$emit('addPropertyToEditor', "{" + property + "}");
    },
    saveTemplate() {
      let vm = this;
      const rules = {
        title: {
          run: (value) => {
            if (!value) {
              return "Please add template title";
            }
            return false;
          },
        },
        message: {
          run: (value) => {
            if (!value) {
              return "Please add template message";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.form.phase = vm.phase;
        if (!vm.form.id) {
          vm.save_template_loading = true;
          vm.$store
            .dispatch("COMMUNICATION_EMAIL_SAVE_TEMPLATE", vm.form)
            .then((responce) => {
              vm.save_template_loading = false;
              vm.$emit("saved");
              vm.$notify({
                group: "status",
                title: "Success",
                text: "Email saved as template",
                type: "success",
                duration: 3000,
              });
            })
            .catch((error) => {
              vm.save_template_loading = false;
              vm.$notify({
                group: "status",
                title: "Warning",
                text: "Something went wrong",
                type: "warn",
                duration: 3000,
              });
            });
        } else {
          vm.save_template_loading = true;
          vm.$store
            .dispatch("COMMUNICATION_EMAIL_UPDATE_TEMPLATE", vm.form)
            .then((responce) => {
              vm.save_template_loading = false;
              vm.$emit("saved");
              vm.$notify({
                group: "status",
                title: "Success",
                text: "Email saved as template",
                type: "success",
                duration: 3000,
              });
            })
            .catch((error) => {
              vm.save_template_loading = false;
              vm.$notify({
                group: "status",
                title: "Warning",
                text: "Something went wrong",
                type: "warn",
                duration: 3000,
              });
            });
        }

      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.template-message-editor-options {
  position: relative;

  .btn-template-message-properties {
    position: absolute;
    top: 52px;
    left: 5px;
    z-index: 9999;

    .btn-icon {
      width: 10px;
    }
  }
}
</style>


